import { FunctionComponent, ReactNode, useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import SwiperCard from '../swiperCard';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import ScrollMagicFn from '@/utils/ScrollMagic';
import EFVideo from '@/components/UI/EFVideo';

const { EFPic } = createEFPic('/img/landingPage');
interface PropsType {
    id: string;
}
const SmartControlKit: FunctionComponent<PropsType> = (props) => {
    const { useLang, gtm, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();
    const [winW, setWinW] = useState(375);
    const solutionDetailInfo = [
        {
            img: ['/img/landingPage/product/Smart_Generator.webp', '/img/landingPage/product/Smart_Generator.png'],
            title: 'secM_product1',
            url: `/dual-fuel-smart-generator`,
        },
        {
            img: ['/img/landingPage/product/400W_Solar_Panels.webp', '/img/landingPage/product/400W_Solar_Panels.png'],
            title: 'secM_product2',
            url: `https://${locale}.ecoflow.com/products/400w-portable-solar-panel?variant=${locale === 'ca' ? '42092770263194' : '39998021697609'}`,
        },
        {
            img: ['/img/landingPage/product/DELTA_Pro_Extra_Battery.webp', '/img/landingPage/product/DELTA_Pro_Extra_Battery.png'],
            title: 'secM_product3',
            url: `https://${locale}.ecoflow.com/products/delta-pro-smart-extra-battery`,
        },
    ];
    const buyNow = () => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: t('delta_pro_whole_home.solution3_device'),
                position: `Solution Page_${t('delta_pro_whole_home.solution3_name')}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
        window.open('https://us.ecoflow.com/products/ecoflow-delta-pro-smart-home-panel');
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setWinW(window?.innerWidth || 375);
        }
    }, []);

    // 动画
    let ScrollMagic: any;
    let controller: any;
    if (typeof window !== 'undefined') {
        ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }
    useEffect(() => {
        controller = new ScrollMagic.Controller();
        return () => {
            (ScrollMagic = null), (controller = null);
        };
    }, []);
    const [smartEnter, setSmartEnter] = useState<boolean>(false);
    useEffect(() => {
        const origin = '.scroll-trigger-origin-H';
        const scene = new ScrollMagic.Scene({ triggerElement: origin, triggerHook: 'onLeave', offset: -60 });
        scene.on('enter', () => setSmartEnter(true));
        scene.on('leave', () => setSmartEnter(false));
        controller.addScene(scene);
    }, []);
    const [generatorEnter, setGeneratorEnter] = useState<boolean>(false);
    useEffect(() => {
        const origin = '.scroll-trigger-origin-I';
        const scene = new ScrollMagic.Scene({ triggerElement: origin, triggerHook: 'onEnter', offset: window.innerHeight / 2 });
        scene.on('enter', () => setGeneratorEnter(true));
        scene.on('leave', () => setGeneratorEnter(false));
        controller.addScene(scene);
    }, []);

    return (
        <div className={css.smartControlKit} id={props.id}>
            <div className="content">
                <div className="inner_first">
                    <div className="uninterrupted-power uninterrupted-power1 scroll-trigger-origin-H">
                        <div className={`text-box-wrap content-video-text ${smartEnter ? 'to' : 'from'}`}>
                            <div className={`text-box`}>
                                <div className={`text-box-video ${smartEnter ? 'toLocation' : ''}`}>
                                    <div className="title">{t('secH_title_h5')}</div>
                                    <div className="text">{t('secH_desc')}</div>
                                </div>
                            </div>
                        </div>
                        <div className="video-box">
                            {['sa'].includes(locale) && (
                                <EFVideo
                                    className="video-box"
                                    sources={['/video/landingPage/h5/dp2.mp4', '/video/landingPage/h5/dp2.mp4']}
                                    poster="/video/landingPage/h5/dp.png"
                                    autoPlay
                                />
                            )}
                            {!['sa'].includes(locale) && (
                                <EFVideo
                                    className="video-box"
                                    sources={['/video/landingPage/h5/dp.webm', '/video/landingPage/h5/dp.mp4']}
                                    poster="/video/landingPage/h5/dp.png"
                                    autoPlay
                                />
                            )}
                        </div>
                    </div>
                    <div className="swiper scene-swiper-box">
                        <Swiper
                            modules={[Autoplay, Pagination]}
                            className="solution-swiper swiper-box"
                            pagination={{
                                clickable: true,
                            }}
                            navigation={false}
                            initialSlide={0}
                            autoplay={false}
                            speed={800}
                            spaceBetween={10}
                            centeredSlides={true}
                        >
                            <SwiperSlide>
                                <div className="img-box">
                                    <EFPic
                                        name={['/h5/solution/Smart Control Kit.webp', '/h5/solution/Smart Control Kit.jpg']}
                                        alt={t('delta_pro_whole_home.solution3_name')}
                                    />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="img-box">
                                    <EFPic
                                        name={['/product/Smart_Control_Kit.webp', '/product/Smart_Control_Kit.png']}
                                        alt={t('delta_pro_whole_home.solution3_name')}
                                    />
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                    <div className="info-box">
                        <div className="name">{t('delta_pro_whole_home.solution3_name')}</div>
                        <div className="device">{t('delta_pro_whole_home.solution3_device')}</div>
                        <div className="power">
                            {t.rich('delta_pro_whole_home.solution3_list', {
                                line1: (child: ReactNode) => <div>{child} </div>,
                                line2: (child: ReactNode) => <div>{child} </div>,
                                line3: (child: ReactNode) => <div>{child} </div>,
                                line4: (child: ReactNode) => <div>{child} </div>,
                            })}
                        </div>
                        <div className="desc">{t('delta_pro_whole_home.solution3_desc2')}</div>
                    </div>
                    <div className="buy-box" onClick={() => buyNow()}>
                        <div className="buy-btn">{t('buy_now')}</div>
                        <div className="buy-desc">{t('delta_pro_whole_home.solution3_buy_desc')}</div>
                    </div>
                </div>
                <div className="uninterrupted-power uninterrupted-power2 scroll-trigger-origin-I">
                    <EFPic name={['/h5/solution/generator.webp', '/h5/solution/generator.png']} alt={t('delta_pro_whole_homesec.I_title')} />
                    <div className={`text-box-wrap  content-generator-text ${generatorEnter ? 'to' : 'from'}`}>
                        <div className="text-box">
                            <div className="title">{t('secI_title')}</div>
                            <div className="text">{t('secI_desc')}</div>
                        </div>
                    </div>
                </div>
                <div className="swiper generator-swiper">
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        className="solution-detail-swiper"
                        pagination={{
                            clickable: true,
                        }}
                        navigation={false}
                        initialSlide={0}
                        autoplay={false}
                        speed={800}
                        centeredSlides={true}
                        lazy={true}
                        spaceBetween={(winW / 375) * 10}
                        slidesPerView={'auto'}
                    >
                        {solutionDetailInfo?.map((item: any, k: number) => (
                            <SwiperSlide key={k} className="generator-slide">
                                <SwiperCard item={item} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};
export default SmartControlKit;
